import React from 'react'
import Books from '../../../assets/pngwing.com.png'
import { Button, styled, Typography } from '@mui/material'
import ErrorLayout from '../errorLayout'
import rotas from '../../../services/rotas'
import { useNavigate } from 'react-router-dom'

const ErroCode = styled(Typography)(() => ({
  fontSize: '1rem',
  fontWeight: 'bolder',
  textAlign: 'center'
}))
const ErroTitle = styled(Typography)(() => ({
  fontSize: '2rem',
  lineHeight: '3.5rem',
  textAlign: 'center',
  fontWeight: 'bold'
}))

const StyledBooks = styled('img')(() => ({
  height: '80vh',
  position: 'absolute',
  right: '-10vw',
  bottom: '-10vh',
  zIndex: '-1'
}))

const ErrorDescription = styled(Typography)(() => ({
  background: 'transparent !important',
  marginTop: '1rem',
  fontSize: '1.5rem',
  textAlign: 'center'
}))

const NotFoundError = () => {
  const navigate = useNavigate('')
  return (
    <ErrorLayout>
      <StyledBooks src={Books} />
      <ErroTitle>Página não encontrada!</ErroTitle>
      <ErroCode>Código do erro: 404</ErroCode>
      <ErrorDescription>
        Não conseguimos encontrar esta página!
      </ErrorDescription>
      <Button
        onClick={() => {
          navigate(rotas.home)
        }}
        variant="contained"
        color="leitura"
        sx={{ margin: 'auto', mt: { xs: 6, md: 3 } }}
      >
        Voltar para o inicio
      </Button>
    </ErrorLayout>
  )
}

export default NotFoundError
